export default class AccountAggregation {
  constructor() {
    this.assets = null;
    this.liabilities = null;
    this.accounts = [];
  }
}
